import {
  UPDATE_JOURNAL_CATEGORIES_LIST,
  TOGGLE_JOURNAL_CATEGORIES_LOADING,
  JOURNAL_CATEGORIES_ERROR,
  JOURNAL_CATEGORIES_UPDATE_TOTAL
} from '../actions/journalCategoriesActions'

const initState = {
  name: 'Journal Categories',
  categories: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0
  }
}

const journalCategoriesReducer = (state = initState, action) => {
  // Immutable nested update: return a NEW `categories` object so useSelector detects the change.
  switch (action.type) {
    case UPDATE_JOURNAL_CATEGORIES_LIST:
      return { ...state, categories: { ...state.categories, list: action.payload.value } }
    case JOURNAL_CATEGORIES_UPDATE_TOTAL:
      return { ...state, categories: { ...state.categories, totalRecords: action.payload.value } }
    case TOGGLE_JOURNAL_CATEGORIES_LOADING:
      return { ...state, categories: { ...state.categories, loading: action.payload.value } }
    case JOURNAL_CATEGORIES_ERROR:
      return { ...state, categories: { ...state.categories, error: action.payload.value } }
    default:
      return state
  }
}

export default journalCategoriesReducer
